import { useTranslation } from 'react-i18next'
import { faCircleXmark, faCircleCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { prefixColumns } from '../constants'

interface ScoreProps {
  score?: number
  maxScore: number
  approved: boolean
}

const Score = ({ score, maxScore, approved }: ScoreProps) => {
  const { t } = useTranslation()
  return (
    <span>
      {approved ? (
        <FontAwesomeIcon icon={faCircleCheck} color="#00B47C" />
      ) : (
        <FontAwesomeIcon icon={faCircleXmark} color="#F5222D" />
      )}
      <span className="ml-1">
        {score} / {maxScore}{' '}
        {t(`${prefixColumns}.points`, {
          count: score,
        })}
      </span>
    </span>
  )
}

export default Score
